module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leaving-monitor"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h3', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "page-title"
  }, [_vm._v("Monitor de Saída")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginateCollection.data && _vm.paginateCollection.data.length),
      expression: "paginateCollection.data && paginateCollection.data.length"
    }],
    staticClass: "caption-subject bold uppercase pull-left"
  }, [_c('span', [_vm._v("Página " + _vm._s(_vm.paginateCollection.currentPage) + " (")]), _vm._v(" "), (_vm.paginateCollection.total >= 10) ? _c('span', [_vm._v(_vm._s(_vm.paginateCollection.perPage))]) : _vm._e(), _vm._v(" "), (_vm.paginateCollection.total < 10) ? _c('span', [_vm._v(_vm._s(_vm.paginateCollection.total))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("de " + _vm._s(_vm.paginateCollection.total) + " alunos )")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('clock', {
    staticClass: "pull-right clock",
    attrs: {
      "displaySeconds": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginateCollection.data && _vm.paginateCollection.data.length),
      expression: "paginateCollection.data && paginateCollection.data.length"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped m-b-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle"
  }, [_vm._v("Nome do Aluno")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle"
  }, [_vm._v("Quem irá buscar?")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle"
  }, [_vm._v("Turma")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "bold align-middle",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Previsão de Chegada")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paginateCollection.data), function(student) {
    return _c('tr', {
      staticClass: "has-arrived"
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "25%"
      }
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": student.student.photoURL
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(student.student.name))])]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "25%"
      }
    }, [(student.delegateToSomeone === false) ? _c('span', [_vm._v(_vm._s(student.responsible.name))]) : _vm._e(), _vm._v(" "), (student.delegateToSomeone === true) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(student.delegatedToName)), _c('br'), _vm._v(" "), _c('small', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "text-muted"
    }, [_vm._v("Autorizado por: " + _vm._s(student.responsible.name))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(student.schoolClass.description))]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "20%"
      }
    }, [(student.delegatedEstimatedTimeToPickup) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("now")(student.delegatedEstimatedTimeToPickup)))]) : _vm._e(), _vm._v(" "), (student.estimatedArrivedDateTime) ? _c('span', [_vm._v(_vm._s(_vm._f("now")(student.estimatedArrivedDateTime)))]) : _vm._e(), _vm._v(" "), (student.arrivedDateTime) ? _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("CHEGOU")]) : _vm._e(), _vm._v(" "), (!student.delegatedEstimatedTimeToPickup && !student.estimatedArrivedDateTime && !student.arrivedDateTime) ? _c('span', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }]
    }, [_vm._v("Não disponível")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "width": "5%"
      }
    }, [_c('button', {
      directives: [{
        name: "translate",
        rawName: "v-translate"
      }],
      staticClass: "btn green-meadow",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeStudentItem(student)
        }
      }
    }, [_vm._v("Aluno liberado")])])])
  }))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginateCollection.data && !_vm.paginateCollection.data.length),
      expression: "paginateCollection.data && !paginateCollection.data.length"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "alert alert-info text-center"
  }, [_vm._v("\n\t\t\t\t\t\tAguardando notificação dos pais para liberar saída\n\t\t\t\t\t")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddbfd2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/app/leaving-monitor/leaving-monitor.vue
// module id = 1055
// module chunks = 1